'use strict';

common.View.create('website::partials.Menu', {

	onDOMLoad()
	{
		// Init MMenu?
		if (this.isMmenu())
			this.initMmenu();

	},

	isMmenu()
	{
		return this.element.data('style') === 'mmenu';
	},

	initMmenu()
	{
		// Init MMenu.
		this.element.mmenu({
			'extensions': [
				'position-back',
				'position-right',
                'pagedim-black',
                'theme-white',
                'fx-menu-slide',
                'fx-panels-slide-100',
			]
		});
	}

});
